import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "flex flex--gap-large flex--align-center mb-32" }
const _hoisted_4 = { class: "project-title" }
const _hoisted_5 = {
  key: 1,
  class: "flex flex--justify-end flex--align-start flex--grow"
}
const _hoisted_6 = { class: "flex flex--wrap flex--gap-large flex--justify-space-between mb-40" }
const _hoisted_7 = { key: 8 }
const _hoisted_8 = { class: "flex flex--gap-large flex--align-center mb-32" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " View: ", -1 /* HOISTED */)
const _hoisted_10 = {
  ref: "load_more_trigger",
  class: "load-more-trigger"
}
const _hoisted_11 = { key: 9 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          ($setup.loading_project)
            ? (_openBlock(), _createBlock($setup["PageLoaderComponent"], { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h1", _hoisted_4, _toDisplayString($setup.project.title), 1 /* TEXT */),
                  _createElementVNode("button", {
                    class: _normalizeClass(["favourite-project", [
							{ 'favourite-project--selected': $setup.user_has_favourited_project },
							{ 'favourite-project--toggled': $setup.user_has_toggled_favourite },
							{ 'favourite-project--loading': $setup.loading_favourite }
						]]),
                    onClick: $setup.toggleFavouriteCurrentProject
                  }, null, 2 /* CLASS */),
                  (!$setup.user_is_in_directory)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass(["button button--large", { 'button--disabled button--loading': $setup.setting_subscribed }]),
                        onClick: $setup.toggleSubscribed
                      }, _toDisplayString($setup.subscribed_label), 3 /* TEXT, CLASS */))
                    : _createCommentVNode("v-if", true),
                  ($setup.project.project_status !== 'completed' && $setup.project.project_status !== 'terminated' && !$setup.user_is_client)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("button", {
                          class: "button button--large",
                          onClick: $setup.startUploadFlow
                        }, " Add media ")
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode($setup["TabNavigationComponent"], {
                    tabs: $setup.tabs,
                    "active-tab": $setup.active_tab,
                    "no-margin": true,
                    onSetTab: $setup.setRoute
                  }, null, 8 /* PROPS */, ["tabs", "active-tab"]),
                  (!$setup.user_is_client)
                    ? (_openBlock(), _createBlock($setup["TabNavigationComponent"], {
                        key: 0,
                        tabs: $setup.view_modes,
                        "active-tab": $setup.active_view_mode,
                        "no-margin": true,
                        onSetTab: $setup.setViewMode
                      }, null, 8 /* PROPS */, ["tabs", "active-tab"]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createVNode(_Transition, { name: "fade" }, {
                  default: _withCtx(() => [
                    ($setup.loading_tab)
                      ? (_openBlock(), _createBlock($setup["PageLoaderComponent"], { key: 0 }))
                      : ($setup.active_tab === 'overview' && $setup.project)
                        ? (_openBlock(), _createBlock($setup["ProjectOverviewComponent"], {
                            key: 1,
                            project: $setup.project,
                            submissions: $setup.submissions,
                            "view-mode": $setup.active_view_mode,
                            onSetRoute: $setup.setRoute,
                            onRefreshProject: $setup.refreshProject
                          }, null, 8 /* PROPS */, ["project", "submissions", "view-mode"]))
                        : ($setup.active_tab === 'submissions' && $setup.project && $setup.submissions && $setup.submissions.length)
                          ? (_openBlock(), _createBlock($setup["SubmissionListComponent"], {
                              key: 2,
                              submissions: $setup.submissions,
                              project: $setup.project
                            }, null, 8 /* PROPS */, ["submissions", "project"]))
                          : ($setup.active_tab === 'grid' && $setup.project)
                            ? (_openBlock(), _createBlock($setup["ProjectAssetsComponent"], {
                                key: 3,
                                project: $setup.project,
                                onRefreshProject: $setup.refreshProject
                              }, null, 8 /* PROPS */, ["project"]))
                            : ($setup.active_tab === 'tags' && $setup.project)
                              ? (_openBlock(), _createBlock($setup["ProjectTagsComponent"], {
                                  key: 4,
                                  project: $setup.project
                                }, null, 8 /* PROPS */, ["project"]))
                              : ($setup.active_tab === 'discussion' && $setup.project)
                                ? (_openBlock(), _createBlock($setup["ProjectDiscussionsComponent"], {
                                    key: 5,
                                    project: $setup.project
                                  }, null, 8 /* PROPS */, ["project"]))
                                : ($setup.active_tab === 'directory' && $setup.project)
                                  ? (_openBlock(), _createBlock($setup["ProjectDirectoryComponent"], {
                                      key: 6,
                                      project: $setup.project,
                                      onUpdateDirectory: $setup.updateDirectory
                                    }, null, 8 /* PROPS */, ["project"]))
                                  : ($setup.active_tab === 'scope' && $setup.project)
                                    ? (_openBlock(), _createBlock($setup["ProjectScopeComponent"], {
                                        key: 7,
                                        project: $setup.project
                                      }, null, 8 /* PROPS */, ["project"]))
                                    : ($setup.active_tab === 'notifications')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                          _createElementVNode("div", _hoisted_8, [
                                            _hoisted_9,
                                            _createVNode($setup["LightswitchComponent"], {
                                              label: "All",
                                              "off-label": "All",
                                              checked: $setup.all_filters_active,
                                              disabled: _ctx.loading || $setup.loading_notifications,
                                              onChange: $setup.toggleAllFilters
                                            }, null, 8 /* PROPS */, ["checked", "disabled"]),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filters, (filter, index) => {
                                              return (_openBlock(), _createBlock($setup["LightswitchComponent"], {
                                                key: `filter-${index}`,
                                                label: filter.label,
                                                "off-label": filter.label,
                                                checked: filter.active,
                                                disabled: _ctx.loading || $setup.loading_notifications,
                                                onChange: $event => ($setup.toggleFilter( filter ))
                                              }, null, 8 /* PROPS */, ["label", "off-label", "checked", "disabled", "onChange"]))
                                            }), 128 /* KEYED_FRAGMENT */))
                                          ]),
                                          _createVNode($setup["NotificationsComponent"], {
                                            notifications: $setup.notifications,
                                            "pending-count": $setup.notifications_pagination.pending_count,
                                            loading: $setup.loading_notifications,
                                            onMarkAsRead: $setup.markNotificationAsRead,
                                            onMarkAllAsRead: $setup.markAllNotificationsAsRead
                                          }, null, 8 /* PROPS */, ["notifications", "pending-count", "loading"]),
                                          _withDirectives(_createElementVNode("div", _hoisted_10, null, 512 /* NEED_PATCH */), [
                                            [_vShow, $setup.notifications_pagination.total_count > $setup.notifications.length]
                                          ])
                                        ]))
                                      : (!_ctx.loading)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_11, " No content. "))
                                        : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                })
              ]))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    ($setup.project)
      ? (_openBlock(), _createBlock($setup["UploadModalComponent"], {
          key: 0,
          show: $setup.show_upload_modal,
          project: $setup.project,
          asset: $setup.asset_to_upload_to,
          onCloseModal: $setup.closeUploadModal
        }, null, 8 /* PROPS */, ["show", "project", "asset"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}